import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=40637055&scoped=true"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"
import style0 from "./stock.vue?vue&type=style&index=0&id=40637055&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40637055",
  null
  
)

export default component.exports